module.exports = __webpack_public_path__ + "static/img/img1.f79e1d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1.jpg
// module id = Eaaq
// module chunks = 1